import {useApi} from "@/composables/useApi";
import type {NotificationData, NotificationsResponse} from "@/types/users";
import {useApiUser} from "@/composables/useApiUser";

export const useNotifications = () => {

    const user = useApiUser();

    const notifications = useState<NotificationsResponse | null>('notifications', () => null);
    const unreadNotificationCount = useState<number>('unreadNotificationCount', () => 0)

    const fetchNotifications = async (page: number = 1) => {
        const { data, fetch } = useApi<NotificationsResponse>({
            url: `users/${user.value?.id}/notifications`,
            method: 'GET',
            query: {
                page: page
            }
        });
        await fetch();
        if(data.value) {
            notifications.value = data.value;
        }
    }

    const fetchUnreadNotificationCount = async () => {
        const { data, fetch } = useApi<number>({
            url: `users/${user.value?.id}/unread-notification-count`,
            method: 'GET',
        });
        await fetch();
        if(data.value) {
            unreadNotificationCount.value = data.value;
        }
    }

    const readNotification = async (notification: NotificationData) => {
        if(notification.read_at) {
            return;
        }
        const { data, fetch } = useApi<NotificationData>({
            url: `users/${user.value?.id}/notifications/${notification.id}/read`,
            method: 'PATCH'
        });
        await fetch();

        if(notifications.value?.data && data.value) {
            notifications.value.data[notifications.value.data.findIndex((n: NotificationData) => n.id === notification.id)] = data.value;
        }
    }

    const deleteNotification = async (notification: NotificationData) => {
        const { data, fetch } = useApi<NotificationsResponse>({
            url: `users/${user.value?.id}/notifications/${notification.id}`,
            method: 'DELETE'
        });
        await fetch();

        if(notifications.value && data.value) {
            notifications.value = data.value;
        }
    }

    const deleteAllNotifications = async () => {
        const { data, fetch, error } = useApi<NotificationsResponse>({
            url: `users/${user.value?.id}/notifications`,
            method: 'DELETE'
        });
        await fetch();

        if(error.value) {
            // Add error modal?
            return;
        }

        notifications.value = data.value;
    }

    const readAllNotifications = async () => {
        const { data, fetch } = useApi<NotificationsResponse>({
            url: `users/${user.value?.id}/notifications/read-all`,
            method: 'POST'
        });
        await fetch();

        if(notifications.value && data.value) {
            notifications.value.data.map(function(notification: NotificationData) {
                if(!notification.read_at) {
                    notification.read_at = (new Date()).toDateString();
                }
                return notification;
            })
        }
    }

    return {
        notifications,
        unreadNotificationCount,
        fetchNotifications,
        fetchUnreadNotificationCount,
        readNotification,
        deleteNotification,
        readAllNotifications,
        deleteAllNotifications,
    }
}